import React, { Component } from 'react'
import { connect } from 'react-redux'
import PreAuthCompSample from '../samples/PreAuthCompSample'
import { makePreauthCompletion, setErrorMessage } from '../../../actions/transactionsActions'
import { _DOTNET, _JAVA, _PHP, PREAUTH_COMPLETION_FAIL } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus\n($store_id,$api_token,$status,$mpgRequest);"],
    order_ID: ["completion.SetOrderId(order_id);", "completion.setOrderId(order_id);", "'order_id'=>$order_id"],
    completion_amount: ["completion.SetCompAmount(comp_amount);", "completion.setCompAmount(comp_amount);", "'comp_amount'=>$comp_amount"],
    transaction_number: ["completion.SetTxnNumber(txn_number);", "completion.setTxnNumber(txn_number);", "'txn_number'=>$txn_number"],
    electronic_commerce_indicator: ["completion.SetCryptType(crypt);", "completion.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    customer_ID: ["completion.SetCustId(cust_id);", "completion.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["completion.SetDynamicDescriptor(dynamic_descriptor);", "completion.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    shipping_indicator: ["completion.SetShipIndicator(ship_indicator);", "completion.setShipIndicator(ship_indicator);", "‘ship_indicator’=>$ship_indicator"],
}

export class PreAuthCompletion extends Component {
    onMakePreAuthPress() {
        const { storeId, apiToken, orderId, amount, txnNumber, preAuthSuccess, prevSuccStep } = this.props;
        if(preAuthSuccess && txnNumber !== 'none' && prevSuccStep === 2) {
            this.setState({ showErr: false });
            const preAuthCompRequest = { storeId, apiToken, orderId, amount, txnNumber };
            this.props.makePreauthCompletion(preAuthCompRequest);
        }
        else {
            this.props.setErrorMessage("This transaction has a pre-requisite transaction: Pre-Authorization.", PREAUTH_COMPLETION_FAIL);
        }
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Pre-Authorization Completion</h3>
                <PreAuthCompSample />
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                    <div style={{ width: '25vw', marginLeft: '14vw'}} className="requestButton" onClick={() => this.onMakePreAuthPress()}>
                        Pre-Authorization Completion Request
                    </div>
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Pre-Authorization Completion</b></span>
                <p style={{marginTop: '3vh'}}>Retrieves funds that have been locked (by a Pre-Authorization transaction), and prepares them for settlement into the merchant’s account.</p>
                
                <div className='thingsToConsider'>
                    <b>Things to Consider: </b>
                    <ul>
                        <li>A Pre-Authorization transaction can only be completed once</li>
                        <li>To reverse the full amount of a Pre-Authorization transaction, use the Pre-Authorization Completion transaction with the amount set to 0.00</li>
                        <li>To process this transaction, you need the order ID and transaction number from the original Pre-Authorization transaction</li>
                    </ul>
                </div>

                <p><b>Pre-Authorization Completion transaction object</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return  <code>Completion completion = new Completion();</code>
                    case _JAVA:
                        return <code>Completion completion = new Completion();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’completion', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Pre-Authorization Completion transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(completion);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(completion);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Optional connection object field</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Pre-Authorization Completion transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>completion amount</td>
                        <td><i>String</i><br /><br />10-character decimal<br />Up to 7 digits (dollars) +<br />decimal point (.) + 2 digits<br />(cents) after the decimal<br />point</td>
                        <td><code>{CODES.completion_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>transaction number</td>
                        <td><i>String</i><br /><br />255-character, alphanumeric, hyphens or underscores<br />variable length</td>
                        <td><code>{CODES.transaction_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>Pre-Authorization Completion transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<br /><br /><p className="note"><b>NOTE: </b>{"Some special characters are notallowed:< > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor<br /><br /><p className="note"><b>NOTE: For Pre-Authorization transactions: </b>the value in the dynamic descriptor field will only be carried over to a Pre-Authorization Completion when executing the latter via the Merchant Resource Center; otherwise, the value for dynamic descriptor must be sent again in the Pre-Authorization Completion</p></td>
                        <td><i>String</i><br /><br />20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<br /><br /><p className="note"><b>NOTE: </b>{"Some special characters are notallowed:< > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>shipping indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.shipping_indicator[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, amount, txnNumber } = state.transactions.main.config;
    const { preAuthSuccess, prevSuccStep } = state.transactions.main;
    return { mode, storeId, apiToken, orderId, amount, txnNumber, preAuthSuccess, prevSuccStep, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makePreauthCompletion, setErrorMessage})(PreAuthCompletion)
